module.exports = __webpack_public_path__ + "static/img/icon_point_1.849dce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/icon_point_1.png
// module id = 654
// module chunks = 2